import {
  Briefcase,
  Building2,
  CalendarDays,
  CalendarRange,
  CircleUser,
  Compass,
  Globe,
  Heart,
  Leaf,
  MapPin,
  MessageSquare,
  MessagesSquare,
  Newspaper,
  Rocket,
  Shield,
  Target,
  Trophy,
  Users,
} from "lucide-react";

export const LOGO_SRC = "/logo.png";

export const NAV_KEYS = [
  { key: "mission", href: "#mission" },
  { key: "features", href: "#features" },
  { key: "audience", href: "#audience" },
  { key: "vision", href: "#vision" },
  { key: "contact", href: "#contact" },
] as const;

export const MISSION_ICONS = [Target, Compass, Leaf];
export const FEATURE_ICONS = [Newspaper, CircleUser, MessageSquare];
export const FEATURE_VARIANTS = ["dark", "orange", "light"] as const;
export const AUDIENCE_ICONS = [Trophy, Shield, Building2, Heart, CalendarDays];
export const AUDIENCE_IMAGES = [
  "https://images.unsplash.com/photo-1554068865-24cecd4e34b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHx0ZW5uaXMlMjBtYXRjaCUyMGFjdGlvbnxlbnwwfHx8fDE3ODEwNTU4NDV8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1519766304817-4f37bda74a26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxiYXNrZXRiYWxsJTIwdGVhbSUyMGNoZWVyaW5nfGVufDB8fHx8MTc4MTA1NTg0NXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1577223625816-7546f13df25d?w=900&auto=format&fit=crop&q=80",
  "https://images.unsplash.com/photo-1599158150601-1417ebbaafdd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxzb2NjZXIlMjBmYW5zJTIwc3RhZGl1bSUyMG1hdGNofGVufDB8fHx8MTc4MTA1NTg0NXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?w=900&auto=format&fit=crop&q=80",
];
export const VISION_CARD_ICONS = [Briefcase, Users];
export const VISION_CHIP_ICONS = [
  [Rocket, CalendarRange, Users],
  [MessagesSquare, MapPin, Globe],
];
export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxmcmllbmRzJTIwcGxheWluZyUyMHNwb3J0fGVufDB8fHx8MTc4MjAxNDUzM3ww&ixlib=rb-4.1.0&q=85";
export const MISSION_VIDEO = "/mission.mp4";
export const VISION_CARD_IMAGES = [
  "https://images.unsplash.com/photo-1526232761682-d26e03ac148e?w=1200&auto=format&fit=crop&q=80",
  "/casual-climbing.jpeg",
];
export const VISION_IMAGE = "/tech-connects.jpeg";
